import * as c from "./constant";

export const setMerchants = (merchants) => ({
  type: c.SET_MERCHANTS,
  payload: merchants,
  meta: { retrievedAt: Date.now() },
});

export const setIsRequired = (required) => ({
  type: c.SET_MERCHANT_REQUIRED,
  payload: required,
});
